const language = {
	spanish: {
		header_title: "Automóviles",
		automoviles_yellow_title: "AUTOMÓVILES",
		automoviles_bold_title:
			"Un vehículo es una inversión importante y de vitalidad en la familia, por eso Foresight GPS tiene una plataforma que combina distintas tecnologías para hacer un rastreo efectivo de este tipo de vehículos y mantenerlos seguros.",
		beneficios_yellow_title: "BENEFICIOS",
		beneficios_list: [
			"Reducir los costos de mantenimiento a través de alertas.",
			"Ahorro general al monitorear los hábitos de manejo.",
			"Alertas de uso del vehículo: excesos de velocidad, entrada y salidas de áreas de seguridad, botón de pánico, apagado remoto de motor.",
			"Integración de múltiples sensores para mayor seguridad y personalización de necesidades.",
			"Gestión de combustible.",
			"Soporte de servicio 24/7.",
		],
		ubicacion_yellow_title: "UBICACIÓN EN TIEMPO REAL",
		ubicacion_bold_title:
			"Podrás tener la tranquilidad de saber dónde se encuentran tus vehículos en todo momento a través de tu PC o smartphone.",
		beneficio_1_bold_text: "Uso de tu vehículo",
		beneficio_1_text:
			"Contarás con la recepción de alertas de exceso de velocidad, salidas y entradas a zonas preestablecidas, así como usos fuera de horario que te permitan generar medidas de prevención.",
		beneficio_2_bold_text: "Tu vehículo en caso de robo",
		beneficio_2_text:
			"Contarás con el soporte de la Sala de Monitoreo, quienes te apoyarán en la gestión y coordinación del evento con las autoridades policiales para la ubicación de tu vehículo.",
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_bold_title:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			{
				text: "Sistema de localización vía GPS y dispositivos móviles.",
				column: "1",
			},
			{
				text: "Generador de geocercas, puntos de interés y rutas.",
				column: "1",
			},
			{
				text: "Visibilidad de vehículos sobre mapas digitalizados y fotos satelitales (Google Maps y OSM).",
				column: "1",
			},
			{
				text: "Diversidad de reportes de gestión de conductores y uso de vehículos.",
				column: "1",
			},
			{
				text: "Programar envío recurrente de reportes.",
				column: "1",
			},
			{
				text: "Alertas en tiempo real de incidencias de seguridad y logística.",
				column: "1",
			},
			{
				text: "Apagado remoto del vehículo y detección de manipulación del dispositivo.",
				column: "2",
			},
			{
				text: "Manejo de distintos tipos de vehículos.",
				column: "2",
			},
			{
				text: "Disponibilidad de integración de varios dispositivos.",
				column: "2",
			},
			{
				text: "Gestión de horas de manejo por conductor.",
				column: "2",
			},
			{
				text: "Administración de usuarios por roles.",
				column: "2",
			},
			{
				text: "Soporte de servicio 24/7",
				column: "2",
			},
		],
	},
	english: {
		header_title: "Cars",
		automoviles_yellow_title: "CARS",
		automoviles_bold_title:
			"A vehicle is an important and vital investment in the family, that’s why ForesightGPS offers their platform that takes advantage of different technologies to effectively track your vehicles to keep them safe.",
		beneficios_yellow_title: "BENEFITS",
		beneficios_list: [
			"Reduce maintenance costs through alerts.",
			"Overall savings by tracking driving habits.",
			"Vehicle usage alerts: speeding, entering, and exiting security areas, panic button, remote engine shutdown.",
			"Integration of multiple sensors for greater security and customization needs.",
			"Fuel management.",
			"24/7 support",
		],
		ubicacion_yellow_title: "REAL TIME LOCATION",
		ubicacion_bold_title:
			"You can have peace of mind knowing where your vehicles are always through your PC or smartphone.",
		beneficio_1_bold_text: "Know what use is given to your vehicle.",
		beneficio_1_text:
			"You will receive alerts for speeding, exiting pre-established areas, after hours use of the car, allowing you to take prevention measures.",
		beneficio_2_bold_text: "Locate your vehicle in case of theft.",
		beneficio_2_text:
			"You will have support from the monitoring room, who will accompany you through this event in coordination with police enforcement to locate your vehicle.",
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_bold_title:
			"We have the best technological innovations for the optimal tracking of your mobile assets:",
		caracteristicas_list: [
			{
				text: "Location system through GPS and mobile devices.",
				column: "1",
			},
			{
				text: "Addition of geofences, points of interests and routes.",
				column: "1",
			},
			{
				text: "Vehicle visibility on digital maps and satellite photos (Google Maps and OSM).",
				column: "1",
			},
			{
				text: "Variety of driver management and vehicle usage reports.",
				column: "1",
			},
			{
				text: "Schedule periodic reports.",
				column: "1",
			},
			{
				text: "Real time alerts of security and logistic incidents.",
				column: "1",
			},
			{
				text: "Device tampering detection and remote vehicle shutdown.",
				column: "2",
			},
			{
				text: "Management of different types of vehicles.",
				column: "2",
			},
			{
				text: "Availability of multiple device integration.",
				column: "2",
			},
			{
				text: "Management of driving hours per driver.",
				column: "2",
			},
			{
				text: "User management by roles.",
				column: "2",
			},
			{
				text: "24/7 support",
				column: "2",
			},
		],
	},
};

export default language;